"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.SpotlightCard = void 0;
require("./SpotlightCard.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _ProductCardBody = _interopRequireDefault(require("../ProductCardBody/ProductCardBody"));
var _ProductCardFooter = _interopRequireDefault(require("../ProductCardFooter/ProductCardFooter"));
var _ProductCardHeader = _interopRequireDefault(require("../ProductCardHeader/ProductCardHeader"));
var _Spotlight = _interopRequireDefault(require("../Spotlight/Spotlight"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SpotlightCard component
 *
 * @method
 * @param { SpotlightCardProps} props
 * @returns SpotlightCard
 */

const SpotlightCard = props => {
  const {
    externalActionFullyClickElement,
    // web-site fully clickable action from product.action
    externalBookmarkActionElement,
    // web-site favorites button
    externalFooterActionElement,
    // web-site addToBag/options button element
    externalGraphicImage,
    // web-site graphic image
    externalProductImageElement,
    // web-site product image

    product,
    showAddToBagButton,
    showBookmarkButton,
    spotlight
  } = props;
  if (!spotlight || !product) {
    return null;
  }
  const showBookmark = showBookmarkButton && !!externalBookmarkActionElement;
  const showAddToBag = showAddToBagButton && !!externalFooterActionElement;
  const componentClassName = (0, _classnames.default)('pal-c-SpotlightCard', {});
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    role: "group"
  }, externalActionFullyClickElement && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalActionFullyClickElement)), /*#__PURE__*/_react.default.createElement(_ProductCardHeader.default
  // do we need to send in external product image from web-site since the link to the product would be the same as the image. Current product highlighter only uses Image, not UltaAsset
  , {
    badge: product.badge,
    headerBackgroundColor: "background-xsubtle",
    headerPadding: "default",
    variantLabel: product.variantLabel,
    externalMediaElement: externalProductImageElement
  }), /*#__PURE__*/_react.default.createElement(_Spotlight.default, {
    eyebrow: spotlight.eyebrow,
    externalGraphicImage: externalGraphicImage,
    subtitle: spotlight.subtitle,
    textAlign: "center",
    title: spotlight.title
  }), /*#__PURE__*/_react.default.createElement(_ProductCardBody.default, {
    brandName: {
      text: product.brandName,
      textColor: 'xsubtle',
      textStyle: 'label'
    },
    title: {
      text: product.productName,
      textStyle: 'label'
    },
    eyebrow: product.eyebrow,
    price: {
      kitPrice: product.kitPrice,
      listPrice: product.listPrice,
      salePrice: product.salePrice
    },
    ratings: {
      maxRating: 5,
      rating: product.rating,
      reviewsCount: product.reviewCount,
      reviewAccessibilityLabel: product.reviewAccessibilityLabel
    },
    valueTag: product.promoText,
    secondValueTag: product.additionalOffersText
  }), showAddToBag && /*#__PURE__*/_react.default.createElement(_ProductCardFooter.default, {
    addToBagAction: product.addToBagAction,
    alignment: "left",
    externalFooterActionElement: externalFooterActionElement,
    sponsoredBadgeLabel: product.sponsoredBadgeLabel
  }), showBookmark && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-SpotlightCard__bookmark"
  }, externalBookmarkActionElement && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalBookmarkActionElement))));
};

/**
 * Property type definitions
 * @typedef SpotlightCardProps
 * @type {object}
 * @property {node} externalActionFullyClickElement - web-site fully clickable action from product.action
 * @property {node} externalBookmarkActionElement - web-site bookmark button element
 * @property {object} externalFooterActionElement - web-site addToBag/options button element
 * @property {object} externalGraphicImage - web-site graphic image
 * @property {object} externalProductImageElement - web-site product image
 * @property {object} product - product object with brandName, productName, price, reviews, etc.
 * @property {boolean} showAddToBagButton - Boolean that tells us to show/hide the add to bag button
 * @property {boolean} showBookmarkButton - Boolean that tells us to show/hide the bookmark button
 * @property {object} spotlight - spotlight object with eyebrow, image, subtitle, text alignment, and title
 */
exports.SpotlightCard = SpotlightCard;
const propTypes = exports.propTypes = {
  /**
   * web-site fully clickable action from product.action
   * <Link
   *  variant='absoluteLink'
   *  ariaLabel={ derivedAriaLabel }
   *  href={ product.url }
   * />
   */
  externalActionFullyClickElement: _propTypes.default.object,
  /**
   * web-site bookmark button element
   */
  externalBookmarkActionElement: _propTypes.default.object,
  /**
   * web-site addToBag/options button element
   */
  externalFooterActionElement: _propTypes.default.object,
  /**
   * web-site graphic image
   */
  externalGraphicImage: _propTypes.default.object,
  /**
   * web-site product image
   */
  externalProductImageElement: _propTypes.default.object,
  /**
   * Product object with brandName, productName, price, reviews, etc.
   */
  product: _propTypes.default.object,
  /**
   * Boolean that tells us to show/hide the add to bag button
   */
  showAddToBagButton: _propTypes.default.bool,
  /**
   * Boolean that tells us to show/hide the bookmark button
   */
  showBookmarkButton: _propTypes.default.bool,
  /**
   * Spotlight text and graphic element
   */
  spotlight: _propTypes.default.object
};
SpotlightCard.propTypes = propTypes;
var _default = exports.default = SpotlightCard;